import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M28 8V24C28 26.1875 26.1875 28 24 28H8C5.75 28 4 26.1875 4 24V8C4 5.8125 5.75 4 8 4H24C26.1875 4 28 5.8125 28 8Z'],
  name: 'uiStopSolid'
} as IconDefinition
